import { Button, Grid, Typography } from '@material-ui/core';
import React from 'react'
import { useTraslados } from '../../../hooks/useCases/useTraslados';
import { useDispatch } from 'react-redux';
import { startAlerta } from '../../../actions/ui/alertas';

export const AdministrarSolicitud = ({ estadoActual, handleClose, formValues }) => {
    const { data, put } = useTraslados();
    const dispatch = useDispatch()

    const estadoAuditoria = data.dim.estados[1].id;
    const estadoPendiente = data.dim.estados[2].id;
    const estadoAutorizada = data.dim.estados[3].id;
    const estadoRechazada = data.dim.estados[4].id;
    const estadoFinalizada = data.dim.estados[5].id;

    const buttonsEnviar = [
        {
            show: estadoAuditoria === estadoActual,
            label: "Pendiente Autorizacion",
            onClick: () => {
                formValues.traslado.idTipoTraslado !== "" ? put.administrarSolicitud(data.solicitud.id, estadoPendiente, "Solicitud Enviada Correctamente", handleClose) :
                    dispatch(startAlerta("Datos Traslado No Completados", "error", "Error"))
            },
        },
        {
            show: estadoPendiente === estadoActual,
            label: "Auditoria Administrativa",
            onClick: () => { put.administrarSolicitud(data.solicitud.id, estadoAuditoria, "Solicitud Enviada Correctamente", handleClose) },
        },
    ];

    const buttonsAcciones = [
        {
            show: estadoAuditoria === estadoActual || estadoPendiente === estadoActual || estadoAutorizada === estadoActual,
            label: "Rechazar",
            onClick: () => { put.administrarSolicitud(data.solicitud.id, estadoRechazada, "Solicitud Rechazada Correctamente", handleClose) },
        },
        {
            show: estadoPendiente === estadoActual,
            label: "Autorizar",
            onClick: () => { put.administrarSolicitud(data.solicitud.id, estadoAutorizada, "Solicitud Autorizada Correctamente", handleClose) },
        },
        {
            show: estadoAutorizada === estadoActual,
            label: "Finalizar",
            onClick: () => { put.administrarSolicitud(data.solicitud.id, estadoFinalizada, "Solicitud Finalizada Correctamente", handleClose) },
        },
    ]

    return (
        <Grid container spacing={2} style={{ padding: "1em" }}>
            {
                estadoFinalizada !== estadoActual &&
                <Grid item xs={12}>
                    <Typography
                        variant="h6"
                        style={{
                            textAlign: "center",
                            margin: "1.5rem 0",
                        }}
                    >
                        Enviar a:
                    </Typography>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-evenly",
                            flexWrap: "wrap",
                        }}
                    >
                        {buttonsEnviar.filter(({ show }) => show).map(({ label, onClick }, index) => (
                            <Button
                                style={{ margin: "0.5rem", marginTop: -15, flexBasis: "30%" }}
                                variant="contained"
                                color="secondary"
                                onClick={onClick}
                                key={index}
                            >
                                {label}
                            </Button>
                        ))}
                    </div>
                </Grid>
            }

            <Grid item xs={12}>
                <Typography
                    variant="h6"
                    style={{
                        textAlign: "center",
                        margin: "1.5rem 0",
                        marginTop: 50
                    }}
                >
                    Acciones sobre la Solicitud:
                </Typography>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-evenly",
                        flexWrap: "wrap",
                    }}
                >
                    {buttonsAcciones.filter(({ show }) => show).map(({ label, onClick }, index) => (
                        <Button
                            key={index}
                            style={{
                                margin: "0.5rem",
                                flexBasis: "30%",
                                backgroundColor: label === "Rechazar" ? "red" : "green",
                                color: "white",
                            }}
                            variant="contained"
                            onClick={onClick}
                        >
                            {label}
                        </Button>
                    ))}
                </div>
            </Grid>
        </Grid>
    )
}
